import { render, staticRenderFns } from "./PatientSummary.vue?vue&type=template&id=2ddbe640&"
import script from "./PatientSummary.vue?vue&type=script&lang=js&"
export * from "./PatientSummary.vue?vue&type=script&lang=js&"
import style0 from "./PatientSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports